import { render, staticRenderFns } from "./DescriptionDisplay.vue?vue&type=template&id=53a3a50e&"
import script from "./DescriptionDisplay.vue?vue&type=script&lang=js&"
export * from "./DescriptionDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports